import React from 'react';
import { reduxForm, Field } from 'redux-form';
import { Form, Grid } from 'semantic-ui-react';

import { AERIES_CONFIGURATION_FORM_NAME } from 'Common/FormEnum';
import { TitledCard } from 'Components/';
import { CheckboxField, InputField, SelectField } from 'Common/SemanticWrapper';
import { AeriesFieldEnum } from 'Common/Constants/SISIntegration';

import { ImportFrequencyEnum } from '../../helpers/Constants';

const frequencyOptions = [
  { value: ImportFrequencyEnum.Every24Hours, key: 0, text: 'Every 24 hours' },
  { value: ImportFrequencyEnum.Every12Hours, key: 1, text: 'Every 12 hours' },
  { value: ImportFrequencyEnum.Every6Hours, key: 2, text: 'Every 6 hours' },
  { value: ImportFrequencyEnum.Every3Hours, key: 3, text: 'Every 3 hours' },
  { value: ImportFrequencyEnum.Every2Hours, key: 4, text: 'Every 2 hours' },
  { value: ImportFrequencyEnum.EveryHour, key: 5, text: 'Every hour' },
];

const AeriesConfigurationStepFormContainer = (props) => {
  const removeWhiteSpace = (value) => value.trim();

  return (
    <Form name={AERIES_CONFIGURATION_FORM_NAME}>
      <TitledCard title={'Configuration'}>
        <Grid>
          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                label={'Enable Aeries Integration'}
                name={AeriesFieldEnum.Enabled}
                component={CheckboxField}
                disabled={props.loading}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row style={{ paddingBottom: '30px' }}>
            <Grid.Column width={6}>
              <Field
                label={'Import Frequency'}
                name={AeriesFieldEnum.ImportFrequency}
                component={SelectField}
                options={frequencyOptions}
                disabled={props.loading}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                label={'Base URL'}
                name={AeriesFieldEnum.BaseUrl}
                component={InputField}
                disabled={props.loading}
                normalize={removeWhiteSpace}
              />
            </Grid.Column>
          </Grid.Row>
          <Grid.Row>
            <Grid.Column width={6}>
              <Field
                label={'Certificate'}
                name={AeriesFieldEnum.Certificate}
                component={InputField}
                disabled={props.loading}
                normalize={removeWhiteSpace}
              />
            </Grid.Column>
          </Grid.Row>
        </Grid>
      </TitledCard>
    </Form>
  );
};

const validate = (values) => {
  const errors = {};

  if (
    !values[AeriesFieldEnum.BaseUrl] ||
    (values[AeriesFieldEnum.BaseUrl] && values[AeriesFieldEnum.BaseUrl] === '')
  ) {
    errors[AeriesFieldEnum.BaseUrl] = 'Base URL is required.';
  }

  if (
    !values[AeriesFieldEnum.Certificate] ||
    (values[AeriesFieldEnum.Certificate] &&
      values[AeriesFieldEnum.Certificate] === '')
  ) {
    errors[AeriesFieldEnum.Certificate] = 'Certificate is required.';
  }

  return errors;
};

export const AeriesConfigurationStepForm = reduxForm({
  form: AERIES_CONFIGURATION_FORM_NAME,
  validate,
  enableReinitialize: true,
})(AeriesConfigurationStepFormContainer);



// WEBPACK FOOTER //
// ./src/pages/aeriesintergration/components/AeriesConfigurationStep/AeriesConfigurationForm.js